export const environment = {
  production: true,
  apiUrl: "https://api.fi-we.com/api/",
  hubUrl: "https://api.fi-we.com/hubs/",
  monriToken: "4aa5f0447caaf69601b22f2b62054ee54a3a45f3",
  monriKey: 'key-53ce043ab9c5e0faa06776fd4f4eeb02',
  monriUrl: 'https://ipg.monri.com/v2/',
  firebase: {
    apiKey: "AIzaSyCJi0cQ866lzPR8hYJUs77JUmD4DBpswl8",
    authDomain: "angular-deomo.firebaseapp.com",
    databaseURL: "https://angular-deomo.firebaseio.com",
    projectId: "angular-deomo",
    storageBucket: "angular-deomo.appspot.com",
    messagingSenderId: "175907956497"
  }
};
